import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // Custom global styles (optional)
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap CSS
import App from "./App"; // Main App Component

// Loaded only on ?admin=1, so visitors don't download the dashboard (and its
// CSS) as part of the main bundle.
const AdminDashboard = React.lazy(() => import("./AdminDashboard"));

const isAdmin = new URLSearchParams(window.location.search).get("admin") === "1";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {isAdmin ? (
      <React.Suspense fallback={null}>
        <AdminDashboard />
      </React.Suspense>
    ) : (
      <App />
    )}
  </React.StrictMode>
);
